import { EventEmitter, Inject, Injectable, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SectionService } from 'app/shared/services/section.service';
import { GenericBaseComponent } from '../generic-base/generic-base.component';

@Injectable()
/*@Component({
  selector: 'app-modal-base',
  templateUrl: './modal-base.component.html',
  styleUrls: ['./modal-base.component.scss']
})*/

export abstract class ModalBaseComponent extends GenericBaseComponent {

  @Input() currentObject: any;
  @Input() isReadOnly: boolean;
  @Output() afterSubmitEvent = new EventEmitter<object>();

  private initialObject: any;
  submitIsActive: boolean = false;

  protected addedSuccessfullyMessage: string;
  protected updatedSuccessfullyMessage: string;

  constructor(protected activeModal: NgbActiveModal, protected sectionService?: SectionService, @Inject('sectionName') protected sectionName?: string) {
    super(sectionService, sectionName);
  }

  initializeObject() {
    super.initialize();
    this.initialObject = Object.assign({}, this.currentObject);
  }

  onSubmit(form: NgForm) {
    this.submitIsActive = true;
  }

  /**
   * Releases the submit spinner while leaving the modal open, for a save the backend rejected.
   *
   * onSubmit raises the spinner and only closeModal lowered it again, so a rejected write left an indefinite
   * overlay over a modal that could no longer be dismissed or corrected - the failure was reported in a toast
   * that the user could not act on.
   *
   * Opt-in, and only the payment action modal opts in so far: a caller has to pass an onErrorCallback to
   * postNow/putNow and invoke this from it. The payment request and upgrade credit modals show a spinner the
   * same way and still hang on a rejected save. Lowering it inside the service's own error subscriber would
   * cover every modal at once, but the service holds no reference to the component that owns this flag, so
   * wiring the remaining callers is the way to finish it.
   */
  handleSubmitFailed() {
    this.submitIsActive = false;
  }

  handleSubmit(form: any) {
    this.closeModal();
    this.resetForm(form);
    this.afterSubmitEvent.emit();
  }

  closeModal() {
    this.submitIsActive = false;
    this.activeModal.close();
  }

  resetForm(form?: any) {
    if (form != null) {
      form.reset(this.initialObject);
      this.resetAdditionalFields();
    }
  }

  resetAdditionalFields() {
  }
}
